import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';

import { processCancelacionResponse, formatDatesAssigments, formatOperationNotary } from './utils';

const OPERATION_URL = `${API_CONFIG.API}/node/operation`;
const INCLUDEDS_OPERATION = '?include=dates_assigments,notario_cancelacion';
export const DATESASSIGMENTS_URL = `${API_CONFIG.API}/node/date_assignement`;

export default {
  getData(id) {
    return base.http().get(`${OPERATION_URL}/${id}${INCLUDEDS_OPERATION}`)
      .then(res => processCancelacionResponse(res.data));
  },
  updateOperationNotary(model) {
    return base.http().patch(`${OPERATION_URL}/${model.op}`, formatOperationNotary(model));
  },
  updateDatesAssigments(model) {
    return base.http().patch(`${DATESASSIGMENTS_URL}/${model.date}`, formatDatesAssigments(model));
  },
};



// WEBPACK FOOTER //
// ./src/features/cancelacion/service.js